import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

/**
 * Bouton "Retour" générique : revient à la page précédente dans l'historique
 * du navigateur (sans forcément renvoyer à l'accueil). Si aucun historique
 * n'est disponible (ex: arrivée directe via lien), repli sur `fallback`.
 */
const BackButton = ({ fallback = '/home', label = 'Retour', className = '' }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate(fallback);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`inline-flex items-center gap-2 px-3 py-2 rounded-full glass-panel border border-border text-sm font-medium text-muted-foreground hover:text-primary hover:border-primary transition-all duration-300 hover:-translate-x-0.5 ${className}`}
      aria-label={label}
    >
      <ArrowLeft className="h-4 w-4" />
      {label}
    </button>
  );
};

export default BackButton;
